import React from "react";
import { connect } from "react-redux";
import { Dialog } from "@vitalsource/vstui";
import { actions as modalActions } from "../../../../redux/modals";
import { t } from "../../../core/translate";
import { actions as uiLibraryActions } from "../../../../redux/ui/library";
import { actions as bookActions } from "../../../../redux/book";

class BorrowBookDialog extends React.Component {

  borrowBook() {
    const { result, isbn, localQuery } = this.props;
    this.props.launchBorrowedBook(isbn, {
      location: result,
      search: localQuery,
      context: "search-result"
    });
  }

  render() {
    const { closeModal } = this.props;
    return (
      <Dialog
        open
        primaryActionButton={{
          label: t("library.borrow", "Borrow"),
          onClick: () => this.borrowBook()
        }}
        secondaryActionButton={{
          label: t("base.cancel", "Cancel"),
          onClick: closeModal
        }}
        onRequestClose={closeModal}
        rootSelector={"#bookshelf"}
        title={t("library.borrow-book", "Borrow Book?")}
        size="small"
      >
        <div>{t("library.borrow-book-description")}</div>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  closeModal: () => dispatch(modalActions.closeModal()),
  launchBorrowedBook: (isbn, options) => {
    dispatch(uiLibraryActions.closePanel());
    dispatch(modalActions.closeModal());
    dispatch(bookActions.launchBridgeBook(isbn, options));
  }
});

export default connect(
  null,
  mapDispatchToProps
)(BorrowBookDialog);
